// @flow
import React from 'react';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundImage: `linear-gradient(${theme.palette.greyScale[7]}, ${theme.applyOpacityToHex(theme.palette.greyScale[5], 0.5)})`,
    minHeight: '100px',
    // width: '100%',
  },
  subtitle: {
    color: theme.palette.greyScale[2],
    padding: '8px 0px 0px 24px',
  },
  title: {
    padding: '20px 0 0 20px',
  },
}));

const Title = () => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.header}>
        <Typography
          className={classes.title}
          variant="h5"
        >
          Add Manual Account
        </Typography>
        <Typography variant="subtitle1" className={classes.subtitle}>
          You need to enter your transactions manually for this account.
        </Typography>
      </div>
    </>
  );
};

export default Title;
